import axios from 'axios'
import { endpoints, resources } from 'config'
import { onCLS, onFID, onLCP, onFCP, onINP, onTTFB } from 'web-vitals'

function reportWebVitals (): void {
  onCLS(reportWebVitalsProd)
  onFID(reportWebVitalsProd)
  onLCP(reportWebVitalsProd)
  onFCP(reportWebVitalsProd)
  onINP(reportWebVitalsProd)
  onTTFB(reportWebVitalsProd)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function reportWebVitalsProd (metric: any): void {
  const metricsBody = JSON.stringify(metric)
  const url = `${endpoints.core}${resources.lm}`
  axios.post(url, metricsBody, {
    headers: { 'Content-Type': 'application/json' }
  })
}

export { reportWebVitals } // Change for prod
